import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CountProviderService {
  private benefitsData: any = {};
  private widget = {}

  constructor() {}

  setCount(val: number, key: string) {
    this.widget[key] = val;
  }

  getCount(key: string) {
    return this.widget[key];
  }

  setData(key: string, value: any) {
    this.benefitsData[key] = value;
  }

  getData(key: string) {
    return this.benefitsData[key];
  }

  setBenefits(data: any) {
    this.benefitsData = data;
  }

  getBenefits() {
    return this.benefitsData;
  }

  clearBenefits() {
    this.benefitsData = {};
  }

  clearData() {
    this.benefitsData = {};
    this.widget = {};
  }
}